
'use strict';

import Flickity from 'flickity';
import objectAssign from 'object-assign';


const defaultOptions = {
    wrapAround: true,
    prevNextButtons: false,
    selectedAttraction: 0.07,
    friction: 0.25
};


function onStaticClick(carousel, cellIndex) {
    carousel.select(cellIndex);
}


function setCustomUIEvents(carousel, nextbutton, prevButton) {
    if (nextbutton) {
        nextbutton.addEventListener('click', () => {
            carousel.next(true);
        })
    }

    if (prevButton) {
        prevButton.addEventListener('click', () => {
            carousel.previous(true);
        })
    }
}


function snippetsCarousel(carouselElem, options = defaultOptions, nextbutton, prevButton) {

    return objectAssign({}, {

        init: function() {
            let carousel = new Flickity(carouselElem, options);
            
            carousel.on('staticClick', (event, pointer, cellElement, cellIndex) => {
                onStaticClick(carousel, cellIndex);
            });

            setCustomUIEvents(carousel, nextbutton, prevButton);

            return carousel;
        }

    });
}


export default snippetsCarousel;




/** WEBPACK FOOTER **
 ** ./src/scripts/client/widgets/snippetsCarousel.js
 **/